<template>
  <div>
    <v-data-table
      v-model:expanded="competitionsExpandedHandler"
      :headers="headers"
      :items="competitions"
      :loading="loading"
      :hide-default-header="$vuetify.display.smAndDown"
      hide-default-footer
      disable-sort
      :items-per-page="-1"
      :loading-text="
        $t('common:loading.messsage', 'Loading...', 'Loading message')
      "
      item-value="id"
      class="entsys--table"
    >
      <template #item="{ item, isExpanded, toggleExpand, internalItem }">
        <tr
          :data-competition-code="item.code"
          :class="[
            isExpanded(internalItem) ? 'bg-primary text-white' : '',
            'py-3'
          ]"
        >
          <template v-if="$vuetify.display.mdAndUp">
            <td>
              <div v-if="item.code">
                {{ item.code }}
              </div>
              <div v-if="item.name">
                <b>{{ item.name }}</b>
              </div>
              <AppShowCupSeasons
                v-if="item.cupSeasons && item.cupSeasons.length > 0"
                :cup-seasons="item.cupSeasons"
              />
              <div>
                <AppShowCompetitionGrandPrix :competition="item" />
              </div>
              <div
                v-if="item.competitionLevelId"
                :class="
                  isExpanded(internalItem) ? 'text-white' : 'text-secondary'
                "
              >
                {{ get(item.competitionLevel, "name") }}
              </div>
              <div
                v-if="
                  item.eventcodeId && get(item.eventcode, 'name') != item.code
                "
              >
                {{ get(item.eventcode, "name") }}
              </div>
            </td>
            <td style="width: 20em">
              <AppShowDifficultyLevel
                :competition="item"
                :style="
                  isExpanded(internalItem) ? 'color: white!important' : ''
                "
              />
            </td>
            <td style="width: 19em">
              <div>
                {{ get(item.competitionRule, "name") }}
                {{ isIndoor(item) }}
              </div>
              <div>
                {{ get(item.competitionRule, "description") }}
                {{ isRestricted(item) }}
                {{ isTeamCompetition(item) }}
              </div>
            </td>
            <td class="text-center">
              <AppShowClassRegistrationsCount
                :value="item"
                :force-white="isExpanded(internalItem)"
              />
            </td>
            <td class="text-right">
              <v-btn-expand
                :model-value="isExpanded(internalItem)"
                :color="isExpanded(internalItem) ? 'white' : 'primary'"
                :aria-label="$t('common:expandButton.alt')"
                class="participant-list"
                @click="toggleExpand(internalItem)"
              >
                <template #default="{ active, attrs }">
                  <v-icon v-bind="attrs" :color="active ? 'white' : 'primary'">
                  </v-icon>
                </template>
              </v-btn-expand>
            </td>
          </template>
          <template v-else>
            <td
              :data-competition-code="item.code"
              style="font-size: 12px !important"
            >
              <v-row no-gutters>
                <v-col cols="9">
                  <div v-if="item.code" class="my-2">
                    {{ item.code }}
                  </div>

                  <div v-if="item.name" class="my-2">
                    <b>{{ item.name }}</b>
                  </div>

                  <AppShowCupSeasons
                    v-if="item.cupSeasons && item.cupSeasons.length > 0"
                    :cup-seasons="item.cupSeasons"
                    class="my-2"
                  />

                  <div>
                    <AppShowCompetitionGrandPrix :competition="item" />
                  </div>
                  <div
                    v-if="item.competitionLevelId"
                    :class="
                      isExpanded(internalItem) ? 'text-white' : 'text-secondary'
                    "
                    class="my-2"
                  >
                    {{ get(item.competitionLevel, "name") }}
                  </div>
                  <div
                    v-if="
                      item.eventcodeId &&
                      get(item.eventcode, 'name') != item.code
                    "
                    class="my-1"
                  >
                    {{ get(item.eventcode, "name") }}
                  </div>

                  <div class="my-2">
                    {{ get(item.competitionRule, "name") }}
                    {{ isIndoor(item) }}
                  </div>
                  <div class="my-2">
                    {{ get(item.competitionRule, "description") }}
                    {{ isRestricted(item) }}
                    {{ isTeamCompetition(item) }}
                  </div>
                  <AppShowDifficultyLevel
                    class="my-2"
                    :competition="item"
                    :style="
                      isExpanded(internalItem) ? 'color: white!important' : ''
                    "
                  />
                </v-col>
                <v-col cols="3">
                  <div class="text-center">
                    <v-btn-expand
                      :model-value="isExpanded(internalItem)"
                      class="participant-list"
                      :color="isExpanded(internalItem) ? 'white' : 'primary'"
                      @click="toggleExpand(internalItem)"
                    >
                      <template #default="{ active, attrs }">
                        <v-icon
                          v-bind="attrs"
                          :color="active ? 'white' : 'primary'"
                        >
                        </v-icon>
                      </template>
                    </v-btn-expand>
                  </div>
                  <br />
                  <div>
                    <AppShowClassRegistrationsCount
                      :value="item"
                      :force-white="isExpanded(internalItem)"
                    />
                  </div>
                </v-col>
              </v-row>
            </td>
          </template>
        </tr>
      </template>
      <template #expanded-row="{ item: competition }">
        <tr class="no-hover">
          <td colspan="99" class="pa-0">
            <template v-if="competition.isTeamCompetition">
              <table>
                <thead>
                  <tr>
                    <th class="text-left">
                      <h3>
                        {{
                          $t(
                            "events:EventPage.participants.RegistrationsPerClass.Teams.heading",
                            "Teams"
                          )
                        }}
                      </h3>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="([teamName, team], index) in teamsByClass(
                      competition.id,
                      registrations
                    )"
                    :key="index"
                  >
                    <td>
                      <h3>
                        <strong>
                          {{ teamName }}
                        </strong>
                      </h3>

                      <v-row
                        v-for="(t, tIndex) in team"
                        :key="tIndex"
                        class="mt-0"
                      >
                        <v-col offset-lg="1">
                          <AppShowRegistrationPeople
                            component-name="AppShowAthleteName"
                            :people="t.athletes"
                            :registration-people="t.registrationPeople"
                          />
                          <div v-if="$vuetify.display.mdAndDown" class="">
                            <AppShowRegistrationHorses
                              component-name="AppShowHorseName"
                              :horse-slot-props="{
                                badge: true
                              }"
                              :horses="t.horses"
                              :registration-horses="t.registrationHorses"
                              :component-props="{
                                showIdentifier: true
                              }"
                            />
                          </div>
                        </v-col>
                        <v-col v-if="$vuetify.display.lgAndUp">
                          <AppShowRegistrationHorses
                            component-name="AppShowHorseName"
                            :horse-slot-props="{
                              badge: true
                            }"
                            :horses="t.horses"
                            :registration-horses="t.registrationHorses"
                            :component-props="{
                              showIdentifier: true
                            }"
                          />
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />
            </template>

            <v-data-table
              :headers="byClassHeaders"
              :items="registrationsByClass(competition.id, registrations)"
              :hide-default-header="$vuetify.display.smAndDown"
              :loading="loading"
              hide-default-footer
              disable-sort
              :items-per-page="-1"
              item-value="id"
              class="entsys--table keep-top"
            >
              <template #no-data>
                {{
                  $t(
                    "common:NoResults.messsage",
                    "No data available",
                    "No results message"
                  )
                }}
              </template>
              <template #item="{ item }">
                <template v-if="$vuetify.display.mdAndUp">
                  <tr
                    :data-scroll-focus="'registration-' + item.id"
                    :class="registrationStateColor(item, item.competitionId)"
                  >
                    <td v-if="disciplineName === 'vaulting'">
                      <div class="my-2">
                        {{ item.teamName }}
                      </div>
                    </td>
                    <td v-if="disciplineName === 'vaulting'">
                      <div class="my-2">
                        <AppShowRegistrationPeople
                          component-name="AppShowAthleteName"
                          :people="item.athletes"
                          :registration-people="item.registrationPeople"
                        />
                      </div>
                    </td>
                    <td>
                      <div class="my-2">
                        <template v-if="disciplineName === 'vaulting'">
                          <AppShowAthleteName
                            v-if="item.vaultingLungerPerson"
                            :athlete="item.vaultingLungerPerson"
                          />
                        </template>
                        <template v-else>
                          <AppShowRegistrationPeople
                            component-name="AppShowAthleteName"
                            :people="item.athletes"
                            :registration-people="item.registrationPeople"
                          />

                          <div v-if="disciplineName === 'driving'" class="mt-1">
                            {{
                              $t(
                                "events:EntryForm.driving.grooms.label",
                                "Groom(s)",
                                "Label for the grooms name field in entry form for driving"
                              )
                            }}
                            <AppShowDrivingGrooms :registration="item" />
                            <br />
                            {{
                              $t(
                                "events:EntryForm.driving.CarriageNumber.label",
                                "Carriage number",
                                "Label for the carriage number field in entry form for driving"
                              )
                            }}
                            {{ item.carriageNumber }}
                          </div>

                          <div v-if="item.teamName" class="text-secondary">
                            {{ item.teamName }}
                          </div>
                        </template>
                      </div>
                    </td>
                    <td>
                      <div class="my-2">
                        <AppShowRegistrationHorses
                          component-name="AppShowHorseName"
                          :horse-slot-props="{
                            badge: true
                          }"
                          :horses="item.horses"
                          :registration-horses="item.registrationHorses"
                          :component-props="{
                            showIdentifier: true
                          }"
                        />
                      </div>
                    </td>
                    <td>
                      <div class="my-2">
                        {{ $dayjs.date(item.createdAt, "fullTime") }}
                      </div>
                    </td>
                    <td>
                      <div class="my-2">
                        <template v-if="onlyForRegistrationsMode">
                          <AppShowEntryClassChip
                            v-for="entry in item.entries"
                            :key="entry.id"
                            :entry="entry"
                          />
                        </template>
                        <template v-else>
                          {{
                            $dayjs.date(
                              item.registrationConfirmedAt,
                              "fullTime"
                            )
                          }}
                        </template>
                      </div>
                    </td>
                    <td>
                      <div class="my-2 actions-space">
                        <v-btn-icon
                          v-if="
                            $allowedMutation(
                              item.allowedMutations,
                              'registrationCreateOrUpdate'
                            )
                          "
                          :aria-label="$t('common:editButton.alt')"
                          :to="{
                            name: 'EventRegistrationEditPage',
                            params: {
                              eventId: event.id,
                              registrationId: item.id
                            },
                            state: {
                              returnRoute: {
                                name: 'EventSchedule',
                                hash: '#participants',
                                params: {
                                  eventId: event.id
                                },
                                state: {
                                  routeScrollState: {
                                    querySelector: `[data-scroll-focus='registration-${item.id}']`
                                  }
                                }
                              }
                            }
                          }"
                          icon
                          size="small"
                          class="bg-edit-green"
                        >
                          <v-icon size="small" color="white"> $edit </v-icon>
                        </v-btn-icon>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr
                    :data-scroll-focus="'registration-' + item.id"
                    :class="registrationStateColor(item, item.competitionId)"
                  >
                    <td class="px-5" style="font-size: 12px !important">
                      <div v-if="disciplineName === 'vaulting'">
                        <v-row no-gutters>
                          <v-col>
                            <b>
                              {{
                                $t(
                                  "events:EntryForm.vaulting.teamnamme.label",
                                  "Team name",
                                  "Label for the team name field in entry form for vaulting"
                                )
                              }}
                            </b>
                            <br />
                            {{ item.teamName }}
                          </v-col>
                          <v-col v-if="item.vaultingLungerPerson">
                            <b>
                              {{
                                $t(
                                  "events:EntryForm.vaulting.lunger.label",
                                  "Lunger",
                                  "Label for the lunger name field in entry form for vaulting"
                                )
                              }}
                            </b>
                            <br />
                            <AppShowAthleteName
                              v-if="item.vaultingLungerPerson"
                              :athlete="item.vaultingLungerPerson"
                            />
                          </v-col>
                        </v-row>

                        <v-divider class="my-3" />
                      </div>
                      <v-row no-gutters>
                        <v-col cols="10">
                          <div class="mb-2">
                            <b>
                              {{
                                $t(
                                  "events:common.Athletes.label",
                                  "Athlete",
                                  "Label for athlete in different parts of the system"
                                )
                              }}
                            </b>
                            <AppShowRegistrationPeople
                              component-name="AppShowAthleteName"
                              :people="item.athletes"
                              :registration-people="item.registrationPeople"
                            />
                            <span
                              v-if="
                                item.teamName && !disciplineName === 'vaulting'
                              "
                              class="text-secondary"
                            >
                              {{ item.teamName }}
                            </span>
                          </div>

                          <div>
                            <b>
                              {{
                                $t(
                                  "events:common.Horses.label",
                                  "Horses",
                                  "Label for horses in different parts of the system"
                                )
                              }}
                            </b>
                            <AppShowRegistrationHorses
                              component-name="AppShowHorseName"
                              :horse-slot-props="{
                                badge: true
                              }"
                              :horses="item.horses"
                              :registration-horses="item.registrationHorses"
                              :component-props="{
                                showIdentifier: true
                              }"
                            />
                          </div>
                          <br />
                          <div class="my-1">
                            <strong>{{
                              $t(
                                "events:common.RegisteredAt.label",
                                "Registered at"
                              )
                            }}</strong>
                            <div>
                              {{ $dayjs.date(item.createdAt, "fullTime") }}
                            </div>
                          </div>

                          <div class="my-1">
                            <template v-if="onlyForRegistrationsMode">
                              <strong>{{
                                $t(
                                  "events:common.entryStatus.label",
                                  "Entry status"
                                )
                              }}</strong>
                              <AppShowEntryClassChip
                                v-for="entry in item.entries"
                                :key="entry.id"
                                :entry="entry"
                              />
                            </template>
                            <template v-else-if="item.registrationConfirmedAt">
                              <strong>{{
                                $t(
                                  "events:common.ConfirmedAt.label",
                                  "Confirmed at"
                                )
                              }}</strong>
                              <div>
                                {{
                                  $dayjs.date(
                                    item.registrationConfirmedAt,
                                    "fullTime"
                                  )
                                }}
                              </div>
                            </template>
                          </div>
                        </v-col>
                        <v-col
                          v-if="
                            $allowedMutation(item.allowedMutations, [
                              'registrationCreateOrUpdate',
                              'registrationUnregister'
                            ])
                          "
                          cols="2"
                          style="max-height: 50%"
                          class="d-flex flex-column justify-space-between"
                        >
                          <div
                            class="text-right"
                            style="
                              display: flex;
                              flex-direction: column;
                              align-items: flex-end;
                            "
                          >
                            <v-btn-icon
                              v-if="
                                $allowedMutation(
                                  item.allowedMutations,
                                  'registrationCreateOrUpdate'
                                )
                              "
                              size="small"
                              :to="{
                                name: 'EventRegistrationEditPage',
                                params: {
                                  eventId: event.id,
                                  registrationId: item.id
                                },
                                state: {
                                  returnRoute: {
                                    name: 'EventSchedule',
                                    hash: '#participants',
                                    params: {
                                      eventId: event.id
                                    },
                                    state: {
                                      routeScrollState: {
                                        querySelector: `[data-scroll-focus='registration-${item.id}']`
                                      }
                                    }
                                  }
                                }
                              }"
                              icon
                              class="bg-edit-green"
                            >
                              <v-icon size="small" color="white">
                                $edit
                              </v-icon>
                            </v-btn-icon>
                          </div>
                        </v-col>
                      </v-row>
                      <template v-if="disciplineName === 'driving'">
                        <v-divider class="my-3" />
                        <div>
                          {{
                            $t(
                              "events:EntryForm.driving.grooms.label",
                              "Groom(s)",
                              "Label for the grooms name field in entry form for driving"
                            )
                          }}
                          <AppShowDrivingGrooms :registration="item" />
                          <br />
                          {{
                            $t(
                              "events:EntryForm.driving.CarriageNumber.label",
                              "Carriage number",
                              "Label for the carriage number field in entry form for driving"
                            )
                          }}
                          {{ item.carriageNumber }}
                        </div>
                      </template>
                    </td>
                  </tr>
                </template>
              </template>

              <template #expanded-row="{ item }">
                <tr>
                  <td colspan="99" class="pa-0">
                    <v-card color="strong" class="pa-6">
                      <div class="d-flex justify-end">
                        <v-btn-icon
                          v-if="
                            $allowedMutation(
                              item.allowedMutations,
                              'registrationCreateOrUpdate'
                            )
                          "
                          :aria-label="$t('common:editButton.alt')"
                          :to="{
                            name: 'EventRegistrationEditPage',
                            params: {
                              eventId: event.id,
                              registrationId: item.id
                            },
                            state: {
                              returnRoute: {
                                name: 'EventSchedule',
                                hash: '#participants',
                                params: {
                                  eventId: event.id
                                },
                                state: {
                                  routeScrollState: {
                                    querySelector: `[data-scroll-focus='registration-${item.id}']`
                                  }
                                }
                              }
                            }
                          }"
                          icon
                          class="bg-edit-green"
                        >
                          <v-icon size="small" color="white"> $edit </v-icon>
                        </v-btn-icon>
                      </div>
                    </v-card>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { defineComponent, toRef } from "vue";
import { get } from "lodash-es";
import gql from "fraql";
import { getFederationConfiguration } from "@composables/masterdata/config";
import { useCompetitionHelpers } from "@composables/competition_helpers";
import { useParticipantsHelper } from "./mixin";

import AppShowAthleteName from "@AppShows/person/AppShowAthleteName.vue";
import AppShowRegistrationHorses from "@AppShows/horse/AppShowRegistrationHorses.vue";
import AppShowRegistrationPeople from "@AppShows/person/AppShowRegistrationPeople.vue";
import AppShowDifficultyLevel from "@AppShows/AppShowDifficultyLevel.vue";
import AppShowClassRegistrationsCount from "@AppShows/event/AppShowClassRegistrationsCount.vue";
import AppShowCompetitionGrandPrix from "@AppShows/event/AppShowCompetitionGrandPrix.vue";
import AppShowEntryClassChip from "@AppShows/event/AppShowEntryClassChip.vue";
import AppShowDrivingGrooms from "@AppShows/event/AppShowDrivingGrooms.vue";

import AppShowCupSeasons from "@AppShows/event/AppShowCupSeasons.vue";

export default defineComponent({
  name: "EventParticipantsByClass",
  components: {
    AppShowAthleteName,
    AppShowRegistrationHorses,
    AppShowRegistrationPeople,
    AppShowDifficultyLevel,
    AppShowClassRegistrationsCount,
    AppShowCompetitionGrandPrix,
    AppShowEntryClassChip,
    AppShowDrivingGrooms,
    AppShowCupSeasons
  },
  props: {
    event: {
      type: Object,
      required: true
    },
    registrations: {
      type: Array,
      required: true
    },
    competitions: {
      type: Array,
      required: true
    },
    disciplineName: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    competitionsExpanded: {
      type: Array,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    onlyForRegistrationsMode: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:competitionsExpanded"],
  setup(props) {
    const event = toRef(props, "event");
    const { registrationStateColor, registrationsByClass, teamsByClass } =
      useParticipantsHelper(event);
    const compHelpers = useCompetitionHelpers();
    return {
      ...compHelpers,
      ...getFederationConfiguration(),
      registrationStateColor,
      registrationsByClass,
      teamsByClass
    };
  },
  computed: {
    get: () => get,
    competitionsExpandedHandler: {
      get() {
        return this.competitionsExpanded;
      },
      set(v) {
        this.$emit("update:competitionsExpanded", v);
      }
    },
    byClassHeaders() {
      let headers = [
        {
          value: "athelete",
          title: this.$t(
            "events:common.athlete.label",
            "Athlete",
            "Label for athlete in different parts of the system"
          ),
          sortable: false
        },
        {
          value: "horse",
          title: this.$t(
            "events:common.Horse.label",
            "Horse",
            "Label for horse in different parts of the system"
          ),
          sortable: false
        },
        {
          value: "reg",
          title: this.$t("events:common.RegisteredAt.label", "Registered at"),
          sortable: false
        },
        {
          value: "confirmed",
          title: this.$t("events:common.ConfirmedAt.label", "Confirmed at"),
          sortable: false
        },
        { value: "actions", title: "", sortable: false }
      ];
      if (this.disciplineName === "vaulting") {
        headers = [
          {
            value: "team",
            title: this.$t(
              "events:EntryForm.vaulting.teamnamme.label",
              "Team name",
              "Label for the team name field in entry form for vaulting"
            ),
            sortable: false
          },
          {
            value: "athletes",
            title: this.$t(
              "events:common.athlete.label",
              "Athlete",
              "Label for athlete in different parts of the system"
            ),
            sortable: false
          },
          {
            value: "lunger",
            title: this.$t(
              "events:EntryForm.vaulting.lunger.label",
              "Lunger",
              "Label for the lunger name field in entry form for vaulting"
            ),
            sortable: false
          },
          {
            value: "horse",
            title: this.$t(
              "events:common.Horse.label",
              "Horse",
              "Label for horse in different parts of the system"
            ),
            sortable: false
          },
          {
            value: "reg",
            title: this.$t("events:common.RegisteredAt.label", "Registered at"),
            sortable: false
          },
          {
            value: "confirmed",
            title: this.$t("events:common.ConfirmedAt.label", "Confirmed at"),
            sortable: false
          },
          { value: "actions", title: "", sortable: false }
        ];
      }

      if (this.onlyForRegistrationsMode) {
        const confirmedIndex = headers.findIndex(x => x.value == "confirmed");
        headers[confirmedIndex] = {
          value: "entryStatus",
          title: this.$t("events:common.entryStatus.label", "Entry status"),
          sortable: false
        };
      }
      return headers;
    }
  },
  fragments: {
    competitionFields: gql`
      fragment _ on Competition {
        id
        code
        cupSeasons {
          id
          ${AppShowCupSeasons.fragments.cupSeasonFields}
        }
      }
    `,
    entryFields: gql`
      fragment _ on Entry {
        ${AppShowEntryClassChip.fragments.entryFields}
      }
    `
  }
});
</script>
